import { memo, useMemo } from "react";
import { useRosterFocusStore } from "@/store/rosterFocusStore";
import { cn } from "@/utils/cn";

export type RosterColumnHoverBackdropProps = {
  daysInMonth: number;
  hasPrevTail: boolean;
};

export const RosterColumnHoverBackdrop = memo(
  function RosterColumnHoverBackdrop({
    daysInMonth,
    hasPrevTail,
  }: RosterColumnHoverBackdropProps) {
    const hoveredColumn = useRosterFocusStore((state) => state.hoveredColumn);
    const selectedColumn = useRosterFocusStore((state) => state.selectedColumn);

    const colKeys = useMemo(
      () =>
        Array.from({ length: daysInMonth }, (_, i) => `day${i + 1}` as const),
      [daysInMonth]
    );

    return (
      <div
        className={cn(
          "pointer-events-none absolute top-0 bottom-0 -z-10 flex h-full",
          hasPrevTail ? "left-[528px]" : "left-[324px]"
        )}
        // style={{ left: scheduleStripOffsetPx }}
        data-roster-days-in-month={daysInMonth}
        aria-hidden
      >
        {colKeys.map((colKey) => {
          const isSelected = selectedColumn === colKey;
          const isHovered = hoveredColumn === colKey;
          return (
            <div
              key={colKey}
              data-column={colKey}
              className="flex h-full w-[34px] shrink-0 flex-col"
            >
              <div
                className="h-full w-full"
                style={{
                  backgroundColor: isSelected
                    ? "rgba(169, 223, 254, 0.4)"
                    : isHovered
                      ? "rgba(169, 223, 254, 0.3)"
                      : "transparent",
                }}
              />
            </div>
          );
        })}
      </div>
    );
  }
);
